import { render } from "./PartnerCompaniesForm.vue?vue&type=template&id=6f66d26d"
import script from "./PartnerCompaniesForm.vue?vue&type=script&lang=js"
export * from "./PartnerCompaniesForm.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./PartnerCompaniesForm.vue?vue&type=style&index=1&id=6f66d26d&lang=css"

import exportComponent from "/Users/giovanialves/Documents/projects/vue/web.vidalonga/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__